import React from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Row, Spin} from "antd";
import {ChevronRightIcon, DiamondIcon, FlameIcon, KeyIcon, StorageBoxOutlineIcon} from "@components/icons/Icons";
import {EllipsisOutlined, SyncOutlined} from "@ant-design/icons";
import {formatDateTiny, formatNumber} from "@lib/format";
import {FmvPrice} from "@components/fmv-price";

const MyCollectionBoxListItemMobile = ({
                                     box,
                                     showEditMultiple,
                                     isSelected,
                                     toggleSelected,
                                     navigate,
                                     showTotalFmv,
                                     postRefreshFmv,
                                     refreshFmvResponse,
                                     fmvUpdated,
                                     setEditBox,
                                     setShowRemoveBox,
                                 }) => {

    return (
        <Row className="grid-list-item">
            <Col span={24}>
                <Row>
                    {showEditMultiple && (
                        <Col span={1} className="col-cbx mar-right-10">
                            <Checkbox checked={isSelected} onChange={() => toggleSelected(box.id)}/>
                        </Col>
                    )}
                    <Col span={20}>
                        <div className="font-125em font-bold cursor-pointer titleLink" onClick={() => { navigate('box-issues?view='+box.id); }}>{box.name}</div>
                    </Col>
                </Row>
                <Row>
                    <div className="book-cover-container">
                        <div
                            className="book-cover-img"
                            style={{background: `url(${box && box.image_url}) 0 45% no-repeat`, backgroundSize: "cover"}}
                            onClick={() => {
                                navigate('box-issues?view='+box.id);
                            }}
                        >
                            <StorageBoxOutlineIcon className="whiteCircleIconSmallCircle" />
                        </div>
                    </div>
                </Row>
                <Row className="pad-top-5 flex-vertical-center">
                    <Col span={12} className="flex-row">
                        <div className="valueBadges" >
                            {box.overview.items_key > 0 && (<span className="pad-right-20"><div className="valueBadge keyIssue isActive"><KeyIcon /></div> ({box.overview.items_key})</span>)}
                            {box.overview.items_hot > 0 && (<span className="pad-right-20"><div className="valueBadge hotIssue isActive"><FlameIcon /></div> ({box.overview.items_hot})</span>)}
                            {box.overview.items_rare > 0 && (<span className="pad-right-20"><div className="valueBadge rareIssue isActive"><DiamondIcon /></div> ({box.overview.items_rare})</span>)}
                        </div>
                    </Col>
                    <Col span={12} className="no-wrap flex-align-right flex-vertical-center">
                        <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                            <Menu >
                                <Menu.Item key={0} onClick={() => { if(setEditBox){ setEditBox(box) } }}>Edit Box Info</Menu.Item>
                                <Menu.Item key={1} onClick={() => setShowRemoveBox(true)}>Delete Box</Menu.Item>
                                {/*<Menu.Item key={2} disabled >Mark All As Sold</Menu.Item>*/}
                                {/*<Menu.Item key={3} disabled>Assign Location For All</Menu.Item>*/}
                            </Menu>
                        )}>
                            <Button className="greyButton mar-left-5" size={"small"}>
                                <EllipsisOutlined className="font-12 iconDarkGrey" />
                            </Button>
                        </Dropdown>

                        <Button type="text" href={'/box-issues?view='+box.id} size={"small"} className="chevron-button" >
                            <ChevronRightIcon className="icon24 iconGrey"/>
                        </Button>
                    </Col>
                </Row>
                <Row className="pad-top-10 font-12 text-grey">
                    <p>{box.description}</p>
                </Row>

                <Row className="font-12">
                    <Col span={24}>
                        <div className={"greyPill pad-left-10 pad-right-10 pad-5 font-16"}>
                            Total FMV
                            <span className="float-right text-grey font-normal">
                                Qty: {formatNumber(box.overview.items)}
                            </span>
                        </div>
                    </Col>
                </Row>

                <Spin spinning={refreshFmvResponse.isLoading}>
                    <Row className="pad-top-5 pad-left-10">
                        <Col span={12} className="flex-col">
                            {showTotalFmv ? (
                                <>
                                    <FmvPrice
                                        value={box.fmv}
                                        stale={box.fmv_is_stale}
                                        staleInfo="FMV data is stale, please update."
                                    />
                                    {(box.fmv_can_update && fmvUpdated) && (
                                        <span className='font-10 text-grey'>Updated: {formatDateTiny(fmvUpdated)}</span>
                                    )}
                                </>
                            ):(
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                            )}
                        </Col>
                        <Col span={12}
                             className={'flex-vertical-center flex-align-right pad-right-10 ' + (box.fmv_can_update ? ' cursor-pointer ' : '')}
                             onClick={box.fmv_can_update ? async () => {
                                 await postRefreshFmv({box_id: box.id})
                             } : undefined}
                        >
                            {box.fmv_can_update && (<SyncOutlined className={'fmv-update can-update'} />)}
                        </Col>
                    </Row>
                </Spin>
            </Col>
        </Row>
    );

};

export default MyCollectionBoxListItemMobile;